/** @format */

import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import Select from "react-select";
import { toast } from "react-toastify";
import locationServices from "../../../Services/locationServices";
import csc from "country-state-city";
import Loader from "../../../Components/Loader";
import AutoComplete from "../../AutoComplete";

export const AddPort = () => {
  const [countryList, setCountryList] = useState([]);
  const [countryValue, setCountryValue] = useState("");
  const [cityList, setPortList] = useState([]);
  const [portValue, setPortValue] = useState("");
  const [loader, setLoader] = useState(true);
  const [customErr, setCustomErr] = useState();
  const [portCountry, setPortCountry] = useState();

  const history = useHistory();
  const formik = useFormik({
    initialValues: {
      country_id: "",
      city_name: "",
      air_courier_available: true,
      air_door_courier_available: true,
      sea_courier_available: true,
      sea_door_courier_available: true,
      road_courier_available: true,
      courier_available: false,
      lat: "",
      long: "",
    },
    validationSchema: Yup.object({
      city_name: Yup.string().required("Required"),
      country_id: Yup.string().required("Required"),
      lat: Yup.string().required("Required"),
      long: Yup.string().required("Required"),
    }),
    onSubmit: (values) => {
      // setLoader(true)
      let postData = {
        ...values,
        coordinates: [values.long, values.lat],
        country_id: countryValue.value._id,
      };
      if (!customErr) {
        locationServices.addCity(postData).then((res) => {
          if (res.status) {
            setLoader(false);
            history.push("/port-list");
          } else {
            setLoader(false);
            toast.error(res.message);
          }
        });
      }
    },
  });

  useEffect(() => {
    getCountryList();
  }, []);

  const getPortList = (code) => {
    let cityItem = csc.getCitiesOfCountry(code);
    let array = [];
    cityItem.map((item) => {
      array.push({ value: item, label: item.name });
    });
    setPortList(array);
    setPortValue("");
    formik.setValues({
      ...formik.values,
      city_name: "",
    });
  };

  const getCountryList = () => {
    let param = { page: 1, limit: 300 };

    locationServices.getCountry(param).then((res) => {
      if (res.status) {
        let arry = [];
        res.data.map((list) => {
          arry.push({ value: list, label: list.country_name });
        });
        setCountryList(arry);
        setLoader(false);
      } else {
        toast.error(res.message);
      }
    });
  };

  const onSelectPort = (e) => {
    formik.setValues({
      ...formik.values,
      lat: e.value.latitude,
      long: e.value.longitude,
      city_name: e.value.name,
    });
    setPortValue(e);
    setPortCountry(e);
    if (countryValue.value.country_iso2 === e.value.countryCode) {
      setCustomErr();
    }
  };

  const onSelectCountry = (e) => {
    getPortList(e.value.country_iso2);
    formik.setValues({ ...formik.values, country_id: e.value._id });
    if (portValue && portValue.value.countryCode === e.value.countryCode) {
      alert("1");
      setCustomErr();
      setCountryValue(e);
    } else {
      setCustomErr("Please select port of selected country");
      setCountryValue(e);
    }
  };

  const getDestinationData = (e) => {
    if (
      countryValue &&
      countryValue.value.country_iso2 !== e.country_short_name
    ) {
      setPortCountry(e.country);
      setCustomErr("Please select port of selected country");
    } else {
      formik.setValues({
        ...formik.values,
        lat: e.latitude,
        long: e.longitude,
        city_name: e.city,
      });
      setPortValue(e);
      setCustomErr();
      setPortCountry(e.country);
    }
  };

  return (
    <div className="row">
      <div className="col-lg-12">
        <div className="card">
          <div className="card-body">
            <form className="control-form">
              <div className="mb-3">
                <label className="form-label">Country </label>
                <Select
                  styles={{
                    valueContainer: (provided) => ({
                      ...provided,
                      height: "calc(2.15rem + 2px)",
                      overflowY: "visible",
                    }),
                    control: (provider) => ({
                      ...provider,
                      borderColor: formik.touched.country_id
                        ? !formik.errors.country_id
                          ? "#34c38f"
                          : "#f46a6a"
                        : "#ced4da",
                      boxShadow: "0 0 0 0px #f46a6a",
                    }),
                    placeholder: (provider) => ({
                      ...provider,
                      color: "#a0b0ca",
                    }),
                  }}
                  value={countryValue}
                  onChange={(e) => onSelectCountry(e)}
                  options={countryList}
                />
                {formik.touched.country_id && formik.errors.country_id ? (
                  <div className="text-danger">{formik.errors.country_id}</div>
                ) : null}
              </div>

              <div className="border-custom">
                <div className="mb-3">
                  <label className="form-label">Port name</label>
                  <Select
                    styles={{
                      valueContainer: (provided) => ({
                        ...provided,
                        height: "calc(2.15rem + 2px)",
                        overflowY: "visible",
                      }),
                      control: (provider) => ({
                        ...provider,
                        borderColor: formik.touched.city_name
                          ? !formik.errors.city_name
                            ? "#34c38f"
                            : "#f46a6a"
                          : "#ced4da",
                        boxShadow: "0 0 0 0px #f46a6a",
                      }),
                      placeholder: (provider) => ({
                        ...provider,
                        color: "#a0b0ca",
                      }),
                    }}
                    value={portValue}
                    onChange={(e) => onSelectPort(e)}
                    options={cityList}
                  />
                  {formik.touched.city_name && formik.errors.city_name ? (
                    <div className="text-danger">{formik.errors.city_name}</div>
                  ) : null}
                </div>

                <div className="mb-3 mt-2">
                  <label className="form-label">
                    Add Port &nbsp;
                    <small className="text-muted">
                      ( <span className="text-danger">Notes</span> :- add port
                      name if not available in list)
                    </small>
                  </label>

                  <AutoComplete getData={(e) => getDestinationData(e)} />

                  {formik.touched.city_name && formik.errors.city_name ? (
                    <div className="text-danger">{formik.errors.city_name}</div>
                  ) : null}
                  {customErr && <p className="text-danger">{customErr}</p>}
                </div>
              </div>

              <div className="row my-3">
                <div className="mb-3 col-2">
                  <div className="d-flex justify-content-start">
                    <label
                      className="form-label px-2"
                      htmlFor="country currency"
                    >
                      Air Mode :{" "}
                    </label>
                    <input
                      type="checkbox"
                      id="air_courier_available"
                      switch="success"
                      checked={formik.values.air_courier_available}
                      {...formik.getFieldProps("air_courier_available")}
                    />
                    <label
                      htmlFor="air_courier_available"
                      data-on-label="Yes"
                      data-off-label="No"
                    />
                  </div>
                  {formik.touched.air_courier_available &&
                  formik.errors.air_courier_available ? (
                    <div className="text-danger">
                      {formik.errors.air_courier_available}
                    </div>
                  ) : null}
                </div>
                <div className="mb-3 col-2">
                  <div className="d-flex justify-content-start">
                    <label
                      className="form-label px-2"
                      htmlFor="country currency"
                    >
                      Air Door Mode :{" "}
                    </label>
                    <input
                      type="checkbox"
                      id="air_door_courier_available"
                      switch="success"
                      checked={formik.values.air_door_courier_available}
                      {...formik.getFieldProps("air_door_courier_available")}
                    />
                    <label
                      htmlFor="air_door_courier_available"
                      data-on-label="Yes"
                      data-off-label="No"
                    />
                  </div>
                  {formik.touched.air_door_courier_available &&
                  formik.errors.air_door_courier_available ? (
                    <div className="text-danger">
                      {formik.errors.air_door_courier_available}
                    </div>
                  ) : null}
                </div>
                <div className="mb-3 col-2">
                  <div className="d-flex justify-content-start">
                    <label className="form-label px-2">Sea Mode : </label>
                    <input
                      id="sea_courier_available"
                      type="checkbox"
                      switch="success"
                      checked={formik.values.sea_courier_available}
                      {...formik.getFieldProps("sea_courier_available")}
                    />
                    <label
                      htmlFor="sea_courier_available"
                      data-on-label="Yes"
                      data-off-label="No"
                    />
                  </div>
                  {formik.touched.sea_courier_available &&
                  formik.errors.sea_courier_available ? (
                    <div className="text-danger">
                      {formik.errors.sea_courier_available}
                    </div>
                  ) : null}
                </div>
                <div className="mb-3 col-2">
                  <div className="d-flex justify-content-start">
                    <label className="form-label px-2">Sea Door Mode : </label>
                    <input
                      id="sea_door_courier_available"
                      type="checkbox"
                      switch="success"
                      checked={formik.values.sea_door_courier_available}
                      {...formik.getFieldProps("sea_door_courier_available")}
                    />
                    <label
                      htmlFor="sea_door_courier_available"
                      data-on-label="Yes"
                      data-off-label="No"
                    />
                  </div>
                  {formik.touched.sea_door_courier_available &&
                  formik.errors.sea_door_courier_available ? (
                    <div className="text-danger">
                      {formik.errors.sea_door_courier_available}
                    </div>
                  ) : null}
                </div>
                <div className="mb-3 col-2">
                  <div className="d-flex justify-content-start">
                    <label className="form-label px-2">Road Mode : </label>
                    <input
                      id="road_courier_available"
                      type="checkbox"
                      switch="success"
                      checked={formik.values.road_courier_available}
                      {...formik.getFieldProps("road_courier_available")}
                    />
                    <label
                      htmlFor="road_courier_available"
                      data-on-label="Yes"
                      data-off-label="No"
                    />
                  </div>
                  {formik.touched.road_courier_available &&
                  formik.errors.road_courier_available ? (
                    <div className="text-danger">
                      {formik.errors.road_courier_available}
                    </div>
                  ) : null}
                </div>
                <div className="mb-3 col-2">
                  <div className="d-flex justify-content-start">
                    <label className="form-label px-2">Courier Mode : </label>
                    <input
                      id="courier_available"
                      type="checkbox"
                      switch="success"
                      checked={formik.values.courier_available}
                      {...formik.getFieldProps("courier_available")}
                    />
                    <label
                      htmlFor="courier_available"
                      data-on-label="Yes"
                      data-off-label="No"
                    />
                  </div>
                  {formik.touched.courier_available &&
                  formik.errors.courier_available ? (
                    <div className="text-danger">
                      {formik.errors.courier_available}
                    </div>
                  ) : null}
                </div>
              </div>
              <div className="row">
                <div className="mb-3 col-6">
                  <label className="form-label">Latitude</label>
                  <input
                    disabled
                    className={
                      "form-control" +
                      (formik.touched.lat
                        ? !formik.errors.lat
                          ? " is-valid"
                          : " is-invalid"
                        : "")
                    }
                    {...formik.getFieldProps("lat")}
                    placeholder="Enter latitude"
                  />
                  {formik.touched.lat && formik.errors.lat ? (
                    <div className="text-danger">{formik.errors.lat}</div>
                  ) : null}
                </div>
                <div className="mb-3 col-6">
                  <label className="form-label">Longitude</label>
                  <input
                    disabled
                    className={
                      "form-control" +
                      (formik.touched.long
                        ? !formik.errors.long
                          ? " is-valid"
                          : " is-invalid"
                        : "")
                    }
                    {...formik.getFieldProps("long")}
                    placeholder="Enter longitude"
                  />
                  {formik.touched.long && formik.errors.long ? (
                    <div className="text-danger">{formik.errors.long}</div>
                  ) : null}
                </div>
              </div>
              <div className="mt-3 d-flex justify-content-between">
                <button
                  className="btn btn-danger w-sm waves-effect waves-light"
                  type="button"
                  onClick={() => history.goBack()}
                >
                  Back
                </button>
                <button
                  className="btn btn-primary w-sm waves-effect waves-light"
                  type="button"
                  onClick={() => formik.handleSubmit()}
                >
                  Submit
                </button>
              </div>
            </form>
          </div>
          <Loader isShow={loader} />
        </div>
      </div>
    </div>
  );
};
